<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->

                <!-- Project Title -->
                <h2>Application Windev réalisé en stage </h2>
                <!-- Project date + duration -->
                <h4><b>Fin :</b> Juin 2021</h4>
                <h4><b>Durée :</b> 10 mois</h4>
                <li><a href="https://github.com/hugo59400/projet-windev">Mon projet sur github</a></li>

                <!-- Project image -->
                <mdb-card-img class="project-picture" src="assets/skills/w.png"></mdb-card-img>
                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/w.png" />
                                <img class="dot" src="assets/skills/github.png" />

                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p>Windev,Github</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>

                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>

                            </p>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
            <!-- Images of the project -->
            <!-- TODO: add images from project -->
            <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/app.png" alt="Capture des test de raymarching">
                </mdb-carousel-item>
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/excel.png" alt="Reconstitution de Immersia à domicile">
                </mdb-carousel-item>
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/compteur.png" alt="Fonctionnalité d'enregistrement de positions dans scènes">
                </mdb-carousel-item>
                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/combo.png" alt="Plateforme Immersia">
                </mdb-carousel-item>

                <mdb-carousel-item>
                    <img class="d-block w-100" src="assets/ges.png" alt="Plateforme Immersia">
                </mdb-carousel-item>




            </mdb-carousel>

        </div>
    </div>
</div>

<app-projects></app-projects>